import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class FcpPeriodPickerService {
    prevMonth(d?: Date): Date {
        let date = d;
        if (!date) date = this.nowDate();
        const m = date.getMonth() - 1;
        const year = date.getFullYear() - (m < 0 ? 1 : 0);
        return new Date(year, m < 0 ? 11 : m, 1);
    }
    nextMonth(d?: Date): Date {
        let date = d;
        if (!date) date = this.nowDate();
        const m = date.getMonth() + 1;
        const year = date.getFullYear() + (m > 11 ? 1 : 0);
        return new Date(year, m > 11 ? 0 : m, 1);
    }
    currentMonth(d?: Date): Date {
        let date = d;
        if (!date) date = this.nowDate();
        return new Date(date.getFullYear(), date.getMonth(), 1);
    }
    nowDate(): Date {
        const d = new Date();
        d.setHours(0, 0, 0, 0);
        return d;
    }
    daysAgo(n: number): Date {
        const d = this.nowDate();
        d.setDate(d.getDate() - n);
        return d;
    }
    monthsAgo(n: number): Date {
        const d = this.nowDate();
        const targetMonth = d.getMonth() - n;
        const targetYear = d.getFullYear() + Math.floor(targetMonth / 12);
        const normalizedMonth = ((targetMonth % 12) + 12) % 12;
        const daysInTarget = new Date(targetYear, normalizedMonth + 1, 0).getDate();
        d.setFullYear(targetYear, normalizedMonth, Math.min(d.getDate(), daysInTarget));
        return d;
    }
    toDateString(date: Date): string {
        const y = date.getFullYear();
        const m = String(date.getMonth() + 1).padStart(2, '0');
        const d = String(date.getDate()).padStart(2, '0');
        return `${y}-${m}-${d}`;
    }
    toUtcDayBoundary(date: Date, edge: 'start' | 'end'): string {
        const y = date.getFullYear();
        const m = String(date.getMonth() + 1).padStart(2, '0');
        const d = String(date.getDate()).padStart(2, '0');
        return edge === 'start' ? `${y}-${m}-${d}T00:00:00.000Z` : `${y}-${m}-${d}T23:59:59.999Z`;
    }
    startOfYear(y: number): Date {
        return new Date(y, 0, 1);
    }
    endOfYear(y: number): Date {
        return new Date(y, 11, 31);
    }
}
